export default __webpack_public_path__ + "static/media/password_open.520fb8b1.svg";